var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Model, Emit, Prop } from 'vue-property-decorator';
import { CaseMarkColor } from '~/config/enum.config.ts';
var CaseMarker = /** @class */ (function (_super) {
    __extends(CaseMarker, _super);
    function CaseMarker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseMarkerList = CaseMarkColor;
        return _this;
    }
    CaseMarker.prototype.emitColor = function (val) { };
    /**
     * 案件标色
     */
    CaseMarker.prototype.caseInfoMarkColor = function () {
        if (!this.selectionList.length) {
            this.$message('请选择要标记的案件');
            return;
        }
    };
    Object.defineProperty(CaseMarker.prototype, "caseMark", {
        get: function () {
            return this.caseColor;
        },
        set: function (val) {
            this.emitColor(val);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ required: true })
    ], CaseMarker.prototype, "selectionList", void 0);
    __decorate([
        Model('change-color')
    ], CaseMarker.prototype, "caseColor", void 0);
    __decorate([
        Emit('change-color')
    ], CaseMarker.prototype, "emitColor", null);
    CaseMarker = __decorate([
        Component({
            components: {},
        })
    ], CaseMarker);
    return CaseMarker;
}(Vue));
export default CaseMarker;
